import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { ManagerActivitiesTabComponent } from './manager-activities-tab/manager-activities-tab.component';
import { OnFieldActivitiesTabComponent } from './on-field-activities-tab/on-field-activities-tab.component';

@Component({
  selector: 'app-supervisors-page',
  imports: [TabsComponent, ManagerActivitiesTabComponent, OnFieldActivitiesTabComponent],
  templateUrl: './supervisors-page.component.html',
  styleUrl: './supervisors-page.component.scss',
})
export class SupervisorsPageComponent extends Route implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  defaultTab = signal<string>('');

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.defaultTab.set(params['tab'] || '');
    });
  }

  onTabChange(tab: string): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
